import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
// import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { registrationTypes } from "../../../../TCPForms/data";
import CompetenceTable from "./CompetenceTable";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";

const SubStep1 = ({ formData, handleSubTabChange, isEmployee, isReapply }) => {
  const { t } = useTranslation();
  // const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();

  const defaultValues = {
    ...formData,
    tradeLicenseDetail: {
      ...formData?.tradeLicenseDetail,
    },
  };
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });

  const watchTradeType = watch("tradeLicenseDetail.tradeUnits.[0].tradeType");
  const watchRegistrationType = watch("registrationType");
  useEffect(() => {
    if (watchRegistrationType === "Architect") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "ARCHITECT.CLASSA");
    } else if (watchRegistrationType === "Town Planner") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "TOWNPLANNER.CLASSA");
    } else if (watchRegistrationType === "Supervisor") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "SUPERVISOR.CLASSA");
    } else if (watchRegistrationType === "Graduate Civil Engineer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "GRADUATECIVILENGINEER.CLASSA");
    } else if (watchRegistrationType === "Structural Engineer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "STRUCTURALENGINEER.CLASSA");
    } else if (watchRegistrationType === "Landscape Architect") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "LANDSCAPEARCHITECT.CLASSA");
    } else if (watchRegistrationType === "Urban Designer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "URBANDESIGNER.CLASSA");
    } else if (watchRegistrationType === "Engineers for Utility Services") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "ENGINEERSUTILITYSERVICES.CLASSA");
    } else {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "");
    }
  }, [watchTradeType, watchRegistrationType]);

  useEffect(() => {
    setValue("department", "DA");
  }, []);

  const onSubmit = (data) => {
    handleSubTabChange(1, data);
  };
  // if (!isEmployee && applicationFlow === null) {
  //   return <DepartmentSelector />;
  // }
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_APPLICANT_TYPE")}</h2>
          </div>
          <div className="formInputContainer common-app-form">
            <div className="columnWrapper">
              <InputWrapper
                control={control}
                data={SortingAlphabatically(registrationTypes)}
                label={`${t("LABEL_APPLICANT_TYPE")}`}
                placeholder="Select Applicant Type"
                name="registrationType"
                defaultValue={formData?.registrationType}
                type="selectInput"
                mandatory
                disabled={isEmployee || (isReapply && formData?.registrationType)}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
              />
            </div>
            <br />
          </div>
        </div>
        {!isEmployee && (
          <div className="formContainer">
            <CompetenceTable type={watchTradeType} />
          </div>
        )}
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              {/* <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => reset()}
                        /> */}
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep1;
